import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-reservacion-vencida',
  templateUrl: './reservacion-vencida.component.html',
  styleUrls: ['./reservacion-vencida.component.scss'],
})
export class ReservacionVencidaComponent implements OnInit {
  @Input() reservacion: any;
  public cotizacion: any;

  constructor(
    private route: ActivatedRoute,
    private readonly location: Location
  ) {
    this.reservacion = JSON.parse(
      sessionStorage.getItem('reservations') || '{}'
    ).find(
      (reservation: any) => reservation.id == this.route.snapshot.params['id']
    );
  }

  ngOnInit(): void {
    this.cotizacion = {
      from: this.reservacion.transaction[0].idCurrencyPayment,
      to: this.reservacion.transaction[0].idCurrencyReceives,
      in: this.reservacion.transaction[0].amountPayment,
      out: this.reservacion.transaction[0].amountReceives,
    };
  }

  atras() {
    this.location.back();
  }
}
